export const daysOnOneWeek = 7;
export const timeFormatEurope = "HH:mm";
export const timeFormat = timeFormatEurope;
export const timeDetailsFormatEurope = "HH:mm:ss";
export const timeDetailsFormat = timeDetailsFormatEurope;
export const timeFormatShortMonthDay = "LLL dd";

export const mobileWidth = 992;
